import { HttpClient } from '@angular/common/http';
import {
    Injectable,
    Injector,
} from '@angular/core';
import { IHostLicense } from '@models';
import { MapperService } from '@services/mapper.service';

import { BaseLicenseService } from 'main/app-state/current-user/license/base-license.service';

@Injectable({
    providedIn: 'root',
})
export class HostLicenseService extends BaseLicenseService<IHostLicense> {
    protected _endpoint = '/odata/HostLicenses';

    constructor(
        http: HttpClient,
        protected _injector: Injector,
    ) {
        super(http, MapperService.hostLicenseMap, _injector);
    }
}
